import Content from './content-interface';

export default class SetInstanceInactivatedHistory implements Content {
  instance: string;

  constructor(obj: any = {}) {
    this.instance = obj.instance || '';
  }

  public static of(obj: any = {}): SetInstanceInactivatedHistory {
    return new SetInstanceInactivatedHistory(obj);
  }
}
